import * as React from 'react'
import { DndProvider } from 'react-dnd'
import { BackendFactory } from 'dnd-core'

type Props = React.PropsWithChildren<{
  backend: BackendFactory
  context?: unknown
  options?: unknown
}>

export const DndRoot: React.FC<Props> = ({ children, backend }) => (
  <DndProvider backend={backend}>{children}</DndProvider>
)
